import React, { useState } from "react";
import { PhoneField } from "../common/fields";
import { isNativeApp } from "../../utils"
import {Button, ButtonGroup} from "@one-thd/sui-atomic-components";

const cancelAutomationId = "edit-phone-modal--button-cancel";
const saveChangesAutomationId = "edit-phone-modal--button-save-changes";

const PhoneEditForm = (props) => {
  const {
    primaryPhone,
    closeForm,
    onSubmit
  } = props;
  const [isValid, setIsValid] = useState(false);
  const [phoneNumEntry, setPhoneNumEntry] = useState("");
  const [isTouched, setIsTouched] = useState(false);

  const onBlur = () => {
    if (!isTouched) setIsTouched(true);
    if (phoneNumEntry.length === 10 && primaryPhone !== phoneNumEntry) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };
  const onChange = (e) => {
    if (e.target.value.length === 10 && primaryPhone !== e.target.value) {
      setIsValid(true);
      setPhoneNumEntry(e.target.value);
    } else if (isTouched) {
      setIsValid(false);
      setPhoneNumEntry(e.target.value);
    }
  };

  const onClickSubmit = (e) => {
    e.preventDefault()
    if (isValid) {
      onSubmit(phoneNumEntry);
    }
  };

  return (
    <form onSubmit={onClickSubmit} className="sui-w-72 sui-grid sui-gap-2">
      <PhoneField
        autoFocus={ !isNativeApp() }  // eslint-disable-line
        onChange={onChange}
        onBlur={onBlur}
        valid={isValid || (!isTouched && !isValid)}/>
      <ButtonGroup responsive>
        <Button variant='primary' onClick={onClickSubmit} disabled={!isValid} data-automation-id={saveChangesAutomationId}>
          Save Changes
        </Button>
        <Button onClick={closeForm} data-automation-id={cancelAutomationId}>
          Cancel
        </Button>
      </ButtonGroup>
    </form>
  );
};

export default PhoneEditForm;
